import { Box, Button, Popover } from "@mui/material"
import { GridActionsCellItem } from "@mui/x-data-grid"
import { useState } from "react"
import EditIcon from '@mui/icons-material/Edit';
import { Trans, useTranslation } from 'react-i18next';

function EditLocationActionItem({ onUpdateDefaultLocation, onDeleteLocation }) {
    const { t } = useTranslation();
    const [anchorEl, setAnchorEl] = useState(null);
    const open = Boolean(anchorEl);
    const id = open ? 'simple-popover' : undefined;

    const handleClick = (event) => {
        setAnchorEl(event.currentTarget);
    };

    const handleClose = () => {
        setAnchorEl(null);
    };

    return (
        <>
            <GridActionsCellItem
                icon={<EditIcon />}
                label={t('hauptstandortFestlegen', { ns: 'instituteConfigurationPage', defaultValue: 'Hauptstandort festlegen' })}
                onClick={handleClick}
            />
            <Popover
                id={id}
                open={open}
                anchorEl={anchorEl}
                onClose={handleClose}
                anchorOrigin={{
                    vertical: 'top',
                    horizontal: 'right',
                }}
                transformOrigin={{
                    vertical: 'center',
                    horizontal: 'left',
                }}
            >
                <Box sx={{ display: 'flex', flexDirection: 'column', p: 1, alignItems: 'flex-start' }}>
                    <Button sx={{ width: '100%' }} variant="text" size="small" onClick={onUpdateDefaultLocation}><Trans i18nKey="hauptstandortFestlegen" ns="instituteConfigurationPage">Hauptstandort setzen</Trans></Button>
                    <Button sx={{ width: '100%' }} variant="text" size="small" onClick={onDeleteLocation}><Trans i18nKey="löschen" ns="instituteConfigurationPage">Löschen</Trans></Button>
                </Box>
            </Popover>
        </>
    );
};

export default EditLocationActionItem
